"use client";

import { cn } from "@/lib/utils";

// Abstract cross/star pattern for top-left decoration
const AbstractCrossPattern = () => (
  <svg
    width="104"
    height="182"
    viewBox="0 0 104 182"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="absolute -left-10 top-5 w-[182px] h-[182px]"
  >
    <path
      d="M62.4324 43.6296C63.1785 44.3556 63.5516 44.7186 64.2977 44.7186C65.0439 44.7186 65.79 44.3556 66.1631 43.6296L69.8939 39.9997L73.6246 43.6296C74.3708 44.3556 74.7438 44.7186 75.49 44.7186C76.2361 44.7186 76.9823 44.3556 77.3554 43.6296C78.4746 42.5407 78.4746 40.7257 77.3554 39.6367L73.6246 36.0068L77.3554 32.3769C78.4746 31.2879 78.4746 29.473 77.3554 28.384C76.2361 27.295 74.3708 27.295 73.2515 28.384L69.5208 32.0139L65.79 28.384C64.6708 27.295 62.8054 27.295 61.6862 28.384C60.567 29.473 60.567 31.2879 61.6862 32.3769L65.417 36.0068L62.4324 39.9997C61.6862 40.7257 61.6862 42.5407 62.4324 43.6296Z"
      fill="#FFF3DA"
    />
    <path
      d="M-12.9287 80.2918C-12.1826 81.0177 -11.8095 81.3807 -11.0633 81.3807C-10.3172 81.3807 -9.57104 81.0177 -9.19796 80.2918L-5.46722 76.6618L-1.73647 80.2918C-0.990318 81.0177 -0.617244 81.3807 0.128906 81.3807C0.875055 81.3807 1.6212 81.0177 1.99428 80.2918C3.1135 79.2028 3.1135 77.3878 1.99428 76.2988L-1.73647 72.6689L1.99428 69.039C3.1135 67.95 3.1135 66.1351 1.99428 65.0461C0.875055 63.9571 -0.99032 63.9571 -2.10954 65.0461L-5.84029 68.676L-9.57104 65.0461C-10.6903 63.9571 -12.5556 63.9571 -13.6749 65.0461C-14.7941 66.1351 -14.7941 67.95 -13.6749 69.039L-9.94412 72.6689L-13.6749 76.2988C-14.0479 77.3878 -14.0479 79.2028 -12.9287 80.2918Z"
      fill="#FFF3DA"
    />
    <path
      d="M6.09814 98.8043C6.84429 99.5303 7.21737 99.8933 7.96352 99.8933C8.70967 99.8933 9.45582 99.5303 9.82889 98.8043L13.5596 95.1744L17.2904 98.8043C18.0365 99.5303 18.4096 99.8933 19.1558 99.8933C19.9019 99.8933 20.6481 99.5303 21.0211 98.8043C22.1404 97.7154 22.1404 95.9004 21.0211 94.8114L17.2904 91.1815L21.0211 87.5516C22.1404 86.4626 22.1404 84.6476 21.0211 83.5587C19.9019 82.4697 18.0365 82.4697 16.9173 83.5587L13.1866 87.1886L9.45582 83.5587C8.33659 82.4697 6.47122 82.4697 5.35199 83.5587C4.23277 84.6476 4.23277 86.4626 5.35199 87.5516L9.08274 91.1815L5.35199 94.8114C4.60584 95.5374 4.60584 97.3524 6.09814 98.8043Z"
      fill="#FFF3DA"
    />
    <path
      d="M24.7518 116.591C25.498 117.317 25.8711 117.68 26.6172 117.68C27.3634 117.68 28.1095 117.317 28.4826 116.591L32.2133 112.961L35.9441 116.591C36.6902 117.317 37.0633 117.68 37.8094 117.68C38.5556 117.68 39.3017 117.317 39.6748 116.591C40.794 115.502 40.794 113.687 39.6748 112.598L35.9441 108.968L39.6748 105.338C40.794 104.249 40.794 102.434 39.6748 101.345C38.5556 100.256 36.6902 100.256 35.571 101.345L31.8403 104.975L28.1095 101.345C26.9903 100.256 25.1249 100.256 24.0057 101.345C22.8865 102.434 22.8865 104.249 24.0057 105.338L27.7364 108.968L24.0057 112.598C24.0057 114.05 24.0057 115.865 24.7518 116.591Z"
      fill="#FFF3DA"
    />
    <path
      d="M43.7787 135.104C44.5248 135.83 44.8979 136.192 45.6441 136.192C46.3902 136.192 47.1364 135.83 47.5094 135.104L51.2402 131.474L54.9709 135.104C55.7171 135.83 56.0901 136.192 56.8363 136.192C57.5824 136.192 58.3286 135.83 58.7017 135.104C59.8209 134.015 59.8209 132.2 58.7017 131.111L54.9709 127.481L58.7017 123.851C59.8209 122.762 59.8209 120.947 58.7017 119.858C57.5824 118.769 55.7171 118.769 54.5979 119.858L50.8671 123.488L47.1364 119.858C46.0171 118.769 44.1518 118.769 43.0325 119.858C41.9133 120.947 41.9133 122.762 43.0325 123.851L46.7633 127.481L43.0325 131.111C42.6595 132.2 42.6595 134.015 43.7787 135.104Z"
      fill="#FFF3DA"
    />
    <path
      d="M-12.1825 43.6296C-11.4364 44.3556 -11.0633 44.7185 -10.3172 44.7185C-9.57101 44.7185 -8.82486 44.3556 -8.45179 43.6296L-4.72104 39.9997L-0.99029 43.6296C-0.244141 44.3556 0.128935 44.7185 0.875084 44.7185C1.62123 44.7185 2.36738 44.3556 2.74046 43.6296C3.85968 42.5406 3.85968 40.7256 2.74046 39.6367L-0.99029 36.0067L3.11353 32.7398C4.23276 31.6508 4.23276 29.8359 3.11353 28.7469C1.99431 27.6579 0.128935 27.6579 -0.99029 28.7469L-4.72104 32.3768L-8.45179 28.7469C-9.57101 27.6579 -11.4364 27.6579 -12.1825 28.7469C-13.3018 29.8359 -13.3018 31.6508 -12.1825 32.7398L-8.45179 36.3697L-12.1825 39.9997C-13.6748 40.7256 -13.6748 42.5406 -12.1825 43.6296Z"
      fill="#FFF3DA"
    />
    <path
      d="M6.47125 61.7792C7.2174 62.5052 7.59048 62.8682 8.33663 62.8682C9.08278 62.8682 9.82893 62.5052 10.202 61.7792L13.9327 58.1493L17.6635 61.7792C18.4096 62.5052 18.7827 62.8682 19.5289 62.8682C20.275 62.8682 21.0212 62.5052 21.3942 61.7792C22.5135 60.6903 22.5135 58.8753 21.3942 57.7863L17.6635 54.1564L22.1404 50.8895C23.2596 49.8005 23.2596 47.9855 22.1404 46.8966C21.0212 45.8076 19.1558 45.8076 18.0366 46.8966L14.3058 50.5265L10.5751 46.8966C9.45585 45.8076 7.59048 45.8076 6.84433 46.8966C5.35203 48.3485 5.35203 49.8005 6.47125 50.8895L10.202 54.5194L6.47125 58.1493C5.35203 59.2383 5.35203 61.0532 6.47125 61.7792Z"
      fill="#FFF3DA"
    />
    <path
      d="M25.498 80.2918C26.2442 81.0177 26.6173 81.3807 27.3634 81.3807C28.1096 81.3807 28.8557 81.0177 29.2288 80.2918L32.9595 76.6618L36.6903 80.2918C37.4364 81.0177 37.8095 81.3807 38.5557 81.3807C39.3018 81.3807 40.048 81.0177 40.421 80.2918C41.5403 79.2028 41.5403 77.3878 40.421 76.2988L36.6903 72.6689L40.421 69.039C41.5403 67.95 41.5403 66.1351 40.421 65.0461C39.3018 63.9571 37.4364 63.9571 36.3172 65.0461L32.5865 68.676L28.8557 65.0461C27.7365 63.9571 25.8711 63.9571 24.7519 65.0461C23.6327 66.1351 23.6327 67.95 24.7519 69.039L28.4826 72.6689L24.7519 76.2988C24.0057 77.3878 24.0057 79.2028 25.498 80.2918Z"
      fill="#FFF3DA"
    />
    <path
      d="M44.1517 98.8043C44.8979 99.5303 45.271 99.8933 46.0171 99.8933C46.7632 99.8933 47.5094 99.5303 47.8825 98.8043L51.6132 95.1744L55.344 98.8043C56.0901 99.5303 56.4632 99.8933 57.2093 99.8933C57.9555 99.8933 58.7016 99.5303 59.0747 98.8043C60.1939 97.7154 60.1939 95.9004 59.0747 94.8114L55.344 91.1815L59.0747 87.5516C60.1939 86.4626 60.1939 84.6476 59.0747 83.5587C57.9555 82.4697 56.0901 82.4697 54.9709 83.5587L51.2401 87.1886L47.5094 83.5587C46.3902 82.4697 44.5248 82.4697 43.4056 83.5587C42.2864 84.6476 42.2864 86.4626 43.4056 87.5516L47.1363 91.1815L43.4056 94.8114C43.4056 95.5374 43.4056 97.3524 44.1517 98.8043Z"
      fill="#FFF3DA"
    />
    <path
      d="M25.871 43.6296C26.6172 44.3556 26.9903 44.7185 27.7364 44.7185C28.4826 44.7185 29.2287 44.3556 29.6018 43.6296L33.3325 39.9997L37.0633 43.6296C37.8094 44.3556 38.1825 44.7185 38.9287 44.7185C39.6748 44.7185 40.421 44.3556 40.794 43.6296C41.9132 42.5406 41.9132 40.7256 40.794 39.6367L37.8094 36.3697L41.5402 32.7398C42.6594 31.6508 42.6594 29.8359 41.5402 28.7469C40.421 27.6579 38.5556 27.6579 37.4364 28.7469L33.7056 32.3768L29.9749 28.7469C28.8556 27.6579 26.9903 27.6579 25.871 28.7469C24.7518 29.8359 24.7518 31.6508 25.871 32.7398L29.6018 36.3697L26.2441 39.9997C24.7518 40.7256 24.7518 42.5406 25.871 43.6296Z"
      fill="#FFF3DA"
    />
    <path
      d="M62.4324 153.616C63.1785 154.342 63.5516 154.705 64.2977 154.705C65.0439 154.705 65.79 154.342 66.1631 153.616L69.8939 149.986L73.6246 153.616C74.3708 154.342 74.7438 154.705 75.49 154.705C76.2361 154.705 76.9823 154.342 77.3554 153.616C78.4746 152.527 78.4746 150.712 77.3554 149.623L73.6246 145.993L77.3554 142.363C78.4746 141.274 78.4746 139.459 77.3554 138.37C76.2361 137.281 74.3708 137.281 73.2515 138.37L69.5208 142L65.79 138.37C64.6708 137.281 62.8054 137.281 61.6862 138.37C60.567 139.459 60.567 141.274 61.6862 142.363L65.417 145.993L62.4324 149.986C61.6862 151.075 61.6862 152.89 62.4324 153.616Z"
      fill="#FFF3DA"
    />
    <path
      d="M-12.1825 153.616C-11.4363 154.342 -11.0633 154.705 -10.3171 154.705C-9.57098 154.705 -8.82483 154.342 -8.45175 153.616L-4.721 149.986L-0.990255 153.616C-0.244106 154.342 0.128968 154.705 0.875118 154.705C1.62127 154.705 2.36742 154.342 2.74049 153.616C3.85972 152.527 3.85972 150.712 2.74049 149.623L-0.990255 145.993L2.74049 142.363C3.85972 141.274 3.85972 139.459 2.74049 138.37C1.62127 137.281 -0.244107 137.281 -1.36333 138.37L-5.09408 142L-8.82483 138.37C-9.94405 137.281 -11.8094 137.281 -12.9286 138.37C-14.0479 139.459 -14.0479 141.274 -12.9286 142.363L-9.1979 145.993L-12.1825 149.986C-13.6748 151.075 -13.6748 152.89 -12.1825 153.616Z"
      fill="#FFF3DA"
    />
    <path
      d="M25.8711 153.616C26.6172 154.342 26.9903 154.705 27.7364 154.705C28.4826 154.705 29.2287 154.342 29.6018 153.616L33.3326 149.986L37.0633 153.616C37.8095 154.342 38.1825 154.705 38.9287 154.705C39.6748 154.705 40.421 154.342 40.7941 153.616C41.9133 152.527 41.9133 150.712 40.7941 149.623L37.4364 146.356L41.1671 142.726C42.2864 141.637 42.2864 139.822 41.1671 138.733C40.0479 137.644 38.1825 137.644 37.0633 138.733L33.3326 142.363L29.6018 138.733C28.4826 137.644 26.6172 137.644 25.498 138.733C24.3788 139.822 24.3788 141.637 25.498 142.726L29.2287 146.356L25.8711 149.986C24.7518 151.075 24.7518 152.89 25.8711 153.616Z"
      fill="#FFF3DA"
    />
    <path
      d="M44.8979 61.7792C45.6441 62.5052 46.0171 62.8682 46.7633 62.8682C47.5094 62.8682 48.2556 62.5052 48.6287 61.7792L52.3594 58.1493L56.0902 61.7792C56.8363 62.5052 57.2094 62.8682 57.9555 62.8682C58.7017 62.8682 59.4478 62.5052 59.8209 61.7792C60.9401 60.6903 60.9401 58.8753 59.8209 57.7863L56.4632 54.5194L60.194 50.8895C61.3132 49.8005 61.3132 47.9855 60.194 46.8966C59.0748 45.8076 57.2094 45.8076 56.0902 46.8966L52.3594 50.5265L48.6287 46.8966C47.5094 45.8076 45.6441 45.8076 44.5248 46.8966C43.4056 47.9855 43.4056 49.8005 44.5248 50.8895L48.2556 54.5194L44.5248 58.1493C43.7787 59.2383 43.7787 61.0532 44.8979 61.7792Z"
      fill="#FFF3DA"
    />
    <path
      d="M62.4324 116.591C63.1785 117.317 63.5516 117.68 64.2977 117.68C65.0439 117.68 65.79 117.317 66.1631 116.591L69.8939 112.961L73.6246 116.591C74.3708 117.317 74.7438 117.68 75.49 117.68C76.2361 117.68 76.9823 117.317 77.3554 116.591C78.4746 115.502 78.4746 113.687 77.3554 112.598L73.6246 108.968L77.3554 105.338C78.4746 104.249 78.4746 102.434 77.3554 101.345C76.2361 100.256 74.3708 100.256 73.2515 101.345L69.5208 104.975L65.79 101.345C64.6708 100.256 62.8054 100.256 61.6862 101.345C60.567 102.434 60.567 104.249 61.6862 105.338L65.417 108.968L61.6862 112.598C61.6862 114.05 61.6862 115.865 62.4324 116.591Z"
      fill="#FFF3DA"
    />
    <path
      d="M62.4324 80.2918C63.1785 81.0177 63.5516 81.3807 64.2977 81.3807C65.0439 81.3807 65.79 81.0177 66.1631 80.2918L69.8939 76.6618L73.6246 80.2918C74.3708 81.0177 74.7438 81.3807 75.49 81.3807C76.2361 81.3807 76.9823 81.0177 77.3554 80.2918C78.4746 79.2028 78.4746 77.3878 77.3554 76.2988L73.6246 72.6689L77.3554 69.039C78.4746 67.95 78.4746 66.1351 77.3554 65.0461C76.2361 63.9571 74.3708 63.9571 73.2515 65.0461L69.5208 68.676L65.79 65.0461C64.6708 63.9571 62.8054 63.9571 61.6862 65.0461C60.567 66.1351 60.567 67.95 61.6862 69.039L65.417 72.6689L61.6862 76.2988C61.6862 77.3878 61.6862 79.2028 62.4324 80.2918Z"
      fill="#FFF3DA"
    />
    <path
      d="M-13.6749 116.591C-12.9287 117.317 -12.5556 117.68 -11.8095 117.68C-11.0633 117.68 -10.3172 117.317 -9.94412 116.591L-6.21337 112.961L-2.48262 116.591C-1.73647 117.317 -1.3634 117.68 -0.617247 117.68C0.128903 117.68 0.875052 117.317 1.24813 116.591C2.36735 115.502 2.36735 113.687 1.24813 112.598L-2.48262 108.968L1.24813 105.338C2.36735 104.249 2.36735 102.434 1.24813 101.345C0.128903 100.256 -1.73647 100.256 -2.85569 101.345L-6.58644 104.975L-9.57104 101.708C-10.6903 100.619 -12.5556 100.619 -13.6749 101.708C-14.7941 102.797 -14.7941 104.612 -13.6749 105.701L-9.94412 109.331L-13.6749 112.961C-14.7941 114.05 -14.7941 115.865 -13.6749 116.591Z"
      fill="#FFF3DA"
    />
    <path
      d="M5.35199 135.104C6.09814 135.83 6.47122 136.192 7.21737 136.192C7.96352 136.192 8.70966 135.83 9.08274 135.104L12.8135 131.474L16.5442 135.104C17.2904 135.83 17.6635 136.192 18.4096 136.192C19.1558 136.192 19.9019 135.83 20.275 135.104C21.3942 134.015 21.3942 132.2 20.275 131.111L16.5442 127.481L20.275 123.851C21.3942 122.762 21.3942 120.947 20.275 119.858C19.1558 118.769 17.2904 118.769 16.1712 119.858L12.4404 123.488L9.45582 120.221C8.33659 119.132 6.47122 119.132 5.35199 120.221C4.23277 121.31 4.23277 123.125 5.35199 124.214L9.08274 127.844L5.35199 131.474C4.23277 132.2 4.23277 134.015 5.35199 135.104Z"
      fill="#FFF3DA"
    />
  </svg>
);

// Abstract leaf/plant pattern for right side decoration
const AbstractLeafPattern = () => (
  <svg
    width="83"
    height="83"
    viewBox="0 0 83 83"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="absolute right-0 top-[292px] w-[83px] h-[83px]"
  >
    <path
      d="M41.4173 66.2482C40.7551 52.5084 29.4984 41.5828 15.593 41.5828C15.593 55.8192 27.1808 67.407 41.4173 67.5726C55.6537 67.5726 67.2416 55.9848 67.2416 41.5828C53.5017 41.5828 42.245 52.5084 41.4173 66.2482Z"
      fill="#FFF3DA"
    />
    <path
      d="M41.4173 41.4172C55.8193 41.4172 67.4071 29.8294 67.4071 15.4274C53.5017 15.4274 42.245 26.5186 41.4173 40.0929C40.7551 26.5186 29.4984 15.4274 15.593 15.4274C15.593 29.8294 27.1808 41.4172 41.4173 41.4172Z"
      fill="#FFF3DA"
    />
  </svg>
);

interface PageLayoutProps {
  children: React.ReactNode;
  className?: string;
  showDecorations?: boolean;
  style?: React.CSSProperties;
  isWide?: boolean;
  responsive?: boolean;
}

/**
 * PageLayout - A reusable layout component with warm cream background
 * and decorative abstract elements matching the Artha Link design system.
 */
export function PageLayout({
  children,
  className,
  showDecorations = true,
  style,
  isWide = false,
  responsive = false,
}: PageLayoutProps) {
  if (isWide) {
    return (
      <div
        className={cn("min-h-dvh w-full bg-[#FFFAEF]", className)}
        style={style}
      >
        <div className="relative z-10 flex flex-col min-h-dvh w-full">
          {children}
        </div>
        <div
          data-sheet-portal
          className="pointer-events-none fixed inset-0 z-[60]"
        />
      </div>
    );
  }

  if (responsive) {
    return (
      <div className="min-h-dvh w-full bg-[#FFFAEF] flex justify-center">
        <div
          className={cn(
            "relative flex flex-col min-h-dvh w-full bg-[#FFFAEF] overflow-hidden",
            className,
          )}
          data-sheet-portal
          style={style}
        >
          {showDecorations && (
            <div className="absolute inset-0 overflow-hidden pointer-events-none sm:hidden">
              <AbstractCrossPattern />
              <AbstractLeafPattern />
            </div>
          )}
          <div className="relative z-10 flex flex-col min-h-dvh w-full">
            {children}
          </div>
        </div>
        <div
          data-sheet-portal
          className="pointer-events-none fixed inset-0 z-[60]"
        />
      </div>
    );
  }

  return (
    <div className="min-h-dvh w-full sm:bg-[#F3E2BE] bg-[#FFFAEF] flex justify-center sm:pt-10">
      <div
        className={cn(
          "relative flex flex-col min-h-dvh w-full max-w-[437px] mx-auto bg-[#FFFAEF] sm:rounded-t-[28px] sm:shadow-[0px_4px_12px_6px_#00000029] overflow-hidden",
          className,
        )}
        data-sheet-portal
        style={{
          width: "100%",
          maxWidth: 437,
          ...style,
        }}
      >
        {showDecorations && (
          <div className="absolute inset-0 rounded-t-[28px] overflow-hidden pointer-events-none">
            <AbstractCrossPattern />
            <AbstractLeafPattern />
          </div>
        )}
        <div className="relative z-10 flex flex-col min-h-dvh w-full">
          {children}
        </div>
      </div>
      <div
        data-sheet-portal
        className="pointer-events-none fixed inset-0 z-[60]"
      />
    </div>
  );
}

export default PageLayout;
